import { Injectable }             from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
 
import { DataService } from '../services/data/data.service';
 
@Injectable({
  providedIn: 'root',
})

export class ProductsResolverService implements Resolve<any> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    return this.dataService.getProductRefs().pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            return of(item);
          } else { // id not found
            return EMPTY;
          }
        })
      );
  }
}